module.exports = __webpack_public_path__ + "static/Gujarat-logo-a2acaffea25f6677c6c121080abc8920.png";